export const buildCompletionResponseSnapshot = ({
  responses,
  latestResponses,
  currentQuestion,
  currentResponse,
}) => ({
  ...(latestResponses || responses || {}),
  ...(currentQuestion?.id
    ? { [currentQuestion.id]: currentResponse }
    : {}),
});
